import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TextoTermosService } from '../../termos-e-condicoes/texto-termos-contratacao-tag.service';
import { Subject } from 'rxjs';
import { BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';

@Component({
    templateUrl: './termos-liquidacao-modal.component.html'
})
export class TermosLiquidacaoModalComponent implements OnInit, OnDestroy {

    callback: any;
    cienciaDosTermosConfirmada = false;
    termos: string;
    private readonly destroy$ = new Subject();

    constructor(
        private _activeModal: NgbActiveModal,
        private termosService: TextoTermosService,
        private loadingService: BnLoadingService
    ) {
    }

    ngOnDestroy(): void {
        this.destroy$.next(undefined);
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.loadingService.bloqueiaTela();
        this.termosService.termosInformeLiquidacaoOperacao$.subscribe({
            next: (response) => {
                this.termos = response;
                this.loadingService.liberaTela();
            },
            error: () => this.loadingService.liberaTela(),
            complete: () => this.loadingService.liberaTela()
        })
    }

    public cancelar() {
        this._activeModal.dismiss({});
    }

    public ok() {
        this._activeModal.dismiss({});
        this.callback(this.cienciaDosTermosConfirmada);
    }

    changeCheck(event) {
        this.cienciaDosTermosConfirmada = event.target.checked;
    }

}